/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import { Switch, Route } from "react-router-dom";
import Home from "../../containers/Home";
import Datasets from "../../containers/Datasets";
import ClassifierPanel from "../../containers/ClassifierPanel";
import CustomizedSnackbars from "./CustomizedSnackbars";
import { Button, ClickAwayListener } from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  MoreHoriz,
  HelpOutline,
  InfoOutlined,
  ExitToApp
} from "@material-ui/icons";
import Help from "../../containers/Help";
import About from "../../containers/About";
import Algorithms from "../../containers/Algorithms";
import ClassifierPanelAll from "../../containers/ClassifierPanelAll";
import AlgorithmsComparation from "../../containers/AlgorithmsComparation"
import AlgorithmsComparationGraph from "../../containers/AlgorithmsComparationGraph";

const styles = theme => ({
  menu: {
    position: "fixed",
    bottom: 20,
    right: 20,
    backgroundColor: "#4caf50",
    "&:hover": {
      backgroundColor: "#357a38"
    }
  },
  home:{
    height:"100%"
  },
  menuBar: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    bottom: 80,
    right: 20
  },
  iconMenu: {
    fill: "white"
  },
  snackbar: {
    margin: 5
  },
  help: {
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: "#ff9800",
    "&:hover": {
      backgroundColor: "#b26a00"
    }
  },
  about: {
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: "#3f51b5",
    "&:hover": {
      backgroundColor: "#2c387e"
    }
  },
  exit: {
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: "#ff3d00",
    "&:hover": {
      backgroundColor: "#b22a00"
    }
  },
  hideBar: {
    display: "none"
  }
});

class Routes extends Component {
  constructor(props) {
    super(props);
    this.handleGlobalMessage = this.handleGlobalMessage.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.state = {
      hide: true
    };
    this.classifierDontExist = this.classifierDontExist.bind(this);
  }

  classifierDontExist(algorithm) {
    this.props.classifierDontExist(algorithm);
  }

  toggleMenu() {
    this.setState(prevState => ({
      hide: !prevState.hide
    }));
  }

  handleGlobalMessage(type, message) {
    if (type === "error") {
      this.setState({
        error: true,
        message
      });
    } else if (type === "success") {
      this.setState({
        success: true,
        message
      });
    } else if(type === "warning"){
      this.setState({
        warning:true,
        message
      })
    }
  }

  closeSession = () => {
    this.setState({
      hide: true,
      success: true,
      message: "Successfuly logout"
    });
    this.props.closeSession();
  };

  handleClickAway = () => {
    this.setState({
      hide: true
    });
  };

  handleClose = reason => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({
      error: false,
      info: false,
      warning: false,
      success: false
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <Switch>
          <Route
            exact
            path="/"
            render={() => (
              <Home
                  className={classes.home}
                token={this.props.token}
                startSession={this.props.startSession}
                startSessionBeginner={this.props.startSessionBeginner}
                language={this.props.language}
                handleLanguageChange={this.props.handleLanguageChange}
                goToDataset={this.props.goToDatasets}
              />
            )}
          />
          <Route
            exact
            path="/datasets"
            render={() => (
              <Datasets
                  mode={this.props.mode}
                  token={this.props.token}
                  closeSession={this.props.closeSession}
                  handleGlobalMessage={this.handleGlobalMessage}
                  language={this.props.language}
                  handleLanguageChange={this.props.handleLanguageChange}
                  handleDataset={this.props.handleDataset}
                  handleDatasetNewNameBeginner={this.props.handleDatasetNewNameBeginner}
                  handleDatasetNewNameScratch={this.props.handleDatasetNewNameScratch}
                  goToBuilder = {this.props.goToBuilder}
                  classifierDontExist={this.classifierDontExist}
              />
            )}
          />
          <Route
            exact
            path="/classifiers"
            render={() => (
              <ClassifierPanel
                  mode={this.props.mode}
                  algorithm={this.props.algorithm}
                token={this.props.token}
                closeSession={this.props.closeSession}
                handleGlobalMessage={this.handleGlobalMessage}
                language={this.props.language}
                handleLanguageChange={this.props.handleLanguageChange}
                dataset={this.props.dataset}
                classifierDontExist={this.classifierDontExist}
                changeAlgorithm = {this.props.changeAlgorithm}
                changeCheckAlgorithm = {this.props.changeCheckAlgorithm}
                  goToBuilder = {this.props.goToBuilder}
                  goToComparation={this.props.goToComparation}

              />
            )}
          />
          <Route
              exact
              path="/classifiersAll"
              render={() => (
                  <ClassifierPanelAll
                      mode={this.props.mode}
                      changeValues = {this.props.changeValues}
                      algorithm={this.props.algorithm}
                      token={this.props.token}
                      closeSession={this.props.closeSession}
                      handleGlobalMessage={this.handleGlobalMessage}
                      language={this.props.language}
                      handleLanguageChange={this.props.handleLanguageChange}
                      dataset={this.props.dataset}
                      datasetNewBeginner={this.props.datasetNewBeginner}
                      file={this.props.file}
                      classifierDontExist={this.classifierDontExist}
                      changeAlgorithm = {this.props.changeAlgorithm}
                      changeCheckAlgorithm = {this.props.changeCheckAlgorithm}
                  />
              )}
          />
          <Route
              exact
              path="/algorithmsComparation"
              render={() => (
                  <AlgorithmsComparation
                      mode={this.props.mode}
                      token={this.props.token}
                      closeSession={this.props.closeSession}
                      handleGlobalMessage={this.handleGlobalMessage}
                      language={this.props.language}
                      handleAlgorithmClick = {this.props.handleDataset}
                      handleLanguageChange={this.props.handleLanguageChange}
                      handleDataset={this.props.handleDataset}
                      dataset={this.props.dataset}
                      datasetNewBeginner={this.props.datasetNewBeginner}
                      algorithm={this.props.algorithm}
                      classifierExists={this.props.classifierExists}
                      changeAlgorithm={this.props.changeAlgorithm}
                      algorithmChecked = {this.props.algorithmChecked}
                      lastAlgorithm = {this.props.lastAlgorithm}
                      changeAlgorithmDataset = {this.props.changeAlgorithmDataset}
                      values={this.props.values}
                  />
              )}
          />
          <Route
              exact
              path="/algorithmsComparationGraph"
              render={() => (
                  <AlgorithmsComparationGraph
                      mode={this.props.mode}
                      token={this.props.token}
                      closeSession={this.props.closeSession}
                      handleGlobalMessage={this.handleGlobalMessage}
                      language={this.props.language}
                      handleAlgorithmClick = {this.props.handleDataset}
                      handleLanguageChange={this.props.handleLanguageChange}
                      handleDataset={this.props.handleDataset}
                      dataset={this.props.dataset}
                      datasetNewBeginner={this.props.datasetNewBeginner}
                      algorithm={this.props.algorithm}
                      classifierExists={this.props.classifierExists}
                      changeAlgorithm={this.props.changeAlgorithm}
                      algorithmChecked = {this.props.algorithmChecked}
                      lastAlgorithm = {this.props.lastAlgorithm}
                      changeAlgorithmDataset = {this.props.changeAlgorithmDataset}
                      values={this.props.values}
                      goToDisplay={this.props.goToDisplay}
                  />
              )}
          />
          <Route
            exact
            path="/builder"
            render={() => (
              /*<FormBuilder
                changeAlgorithm={this.props.changeAlgorithm}
                dataset={this.props.dataset}
                algorithm={this.props.algorithm}
                classifierExists={this.props.classifierExists}
                token={this.props.token}
                closeSession={this.props.closeSession}
                handleGlobalMessage={this.handleGlobalMessage}
                language={this.props.language}
                handleLanguageChange={this.props.handleLanguageChange}
              />*/
              <Algorithms
                  token={this.props.token}
                  closeSession={this.props.closeSession}
                  handleGlobalMessage={this.handleGlobalMessage}
                  language={this.props.language}
                  handleAlgorithmClick = {this.props.handleDataset}
                  handleLanguageChange={this.props.handleLanguageChange}
                  handleDataset={this.props.handleDataset}
                  dataset={this.props.dataset}
                  algorithm={this.props.algorithm}
                  classifierExists={this.props.classifierExists}
                  changeAlgorithm={this.props.changeAlgorithm}
                  algorithmChecked = {this.props.algorithmChecked}
                  lastAlgorithm = {this.props.lastAlgorithm}
                  changeAlgorithmDataset = {this.props.changeAlgorithmDataset}
              />
            )}
          />
          <Route
            exact
            path="/help"
            render={() => (
              <Help
                token={this.props.token}
                handleGlobalMessage={this.handleGlobalMessage}
                language={this.props.language}
                handleLanguageChange={this.props.handleLanguageChange}
              />
            )}
          />
          <Route
            exact
            path="/about"
            render={() => (
              <About
                handleGlobalMessage={this.handleGlobalMessage}
                language={this.props.language}
                handleLanguageChange={this.props.handleLanguageChange}
              />
            )}
          />
        </Switch>
        <ClickAwayListener onClickAway={this.handleClickAway}>
          <Button
            variant="fab"
            className={classes.menu}
            onClick={this.toggleMenu}
          >
            <MoreHoriz className={classes.iconMenu} />
          </Button>
        </ClickAwayListener>
        <div className={!this.state.hide ? classes.menuBar : classes.hideBar}>
          <Button
            variant="fab"
            className={classes.help}
            onClick={this.props.goToHelp}
          >
            <HelpOutline className={classes.iconMenu} />
          </Button>
          <Button
            variant="fab"
            className={classes.about}
            onClick={this.props.goToAbout}
          >
            <InfoOutlined className={classes.iconMenu} />
          </Button>
          <Button
            variant="fab"
            className={classes.exit}
            onClick={this.closeSession}
          >
            <ExitToApp className={classes.iconMenu} />
          </Button>
        </div>
        <CustomizedSnackbars
          className={classes.snackbar}
          openFail={this.state.error}
          openInfo={this.state.info}
          openSuccess={this.state.success}
          openWarning={this.state.warning}
          handleClose={this.handleClose}
          message={this.state.message}
        />
      </Fragment>
    );
  }
}

Routes.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Routes);
